import { useEffect } from 'react';
import { createRootRoute, Outlet, useRouterState } from '@tanstack/react-router';
import { useAudioPlayer } from '@/stores/audioPlayer';
import { useDeepLinkAuth } from '@/hooks/useDeepLinkAuth';
import { useAppVersionGate } from '@/hooks/useAppVersionGate';
import Toaster from '@/components/Toaster';
import DeviceGate from '@/components/DeviceGate';
import ForceUpdateScreen from '@/components/ForceUpdateScreen';
import UpdatePopin from '@/components/UpdatePopin';

export const Route = createRootRoute({
  component: RootLayout,
});

function RootLayout() {
  const pathname = useRouterState({ select: (s) => s.location.pathname });
  useDeepLinkAuth();
  const { decision: versionGate, latestVersion } = useAppVersionGate();

  // Stop any preview when navigating between screens.
  useEffect(() => {
    useAudioPlayer.getState().stop();
  }, [pathname]);

  return (
    <div
      className="tw:flex tw:flex-col tw:h-dvh tw:overflow-hidden tw:app-background tw:text-white"
      style={{
        paddingTop: 'env(safe-area-inset-top)',
        // No bottom inset here — it would lift the whole app (incl. the tab bar)
        // above the home indicator, leaving a dark strip below the navbar. The
        // bottom tab bar applies its own safe-area-inset-bottom so its background
        // reaches the screen edge while its icons stay above the home indicator.
        paddingLeft: 'env(safe-area-inset-left)',
        paddingRight: 'env(safe-area-inset-right)',
      }}
    >
      <DeviceGate>{versionGate === 'force' ? <ForceUpdateScreen /> : <Outlet />}</DeviceGate>
      {/* E3 — dismissible update suggestion (once per latest_version). */}
      {versionGate === 'soft' && <UpdatePopin latestVersion={latestVersion} />}
      <Toaster />
    </div>
  );
}
